import * as _constants from './constants'
import * as _stylable from './functionLibraryExtensions/stylableFunctionLibrary'

export {
	createFunctionLibrary,
	seoMergeBlob,
	removeHash,
	rgbToHex,
	addCssValueToLayoutSizes,
	getCompDefaultLayout,
	getClassicLayout,
	getClassicTransformation,
	getScaledFontSize,
} from './functionLibrary'
export * from './carmi/root'
export const constants = _constants
export { getAutoHeightWrapperId } from './functionLibraryExtensions/mesh/meshStyle'
export {
	getMeshResult,
	getMeshResultsForMasterPage,
	getMeshResultForHoverBox,
} from './functionLibraryExtensions/mesh/meshFunctionLibrary'
export { sortMasterPageChildrenIntoGroups } from './functionLibraryExtensions/masterPageFunctionLibrary'

export { resolveThemeFontsSpx, convertSingleVariableSpx } from './functionLibraryExtensions/utils/masterPageUtils'
export { getSingleLayoutWithVariablesRefs } from './functionLibraryExtensions/variablesFunctionLibrary'
export { HTMLParser } from './functionLibraryExtensions/utils/htmlParser'
export { variantSeparator } from './functionLibraryExtensions/variants/constants'
export * from './types'
export * from './utils'

export {
	fixOriginalFont,
	fixFontFamily,
	getFontColor,
	getMobileScaledFont,
	getScaledFont,
	textThemeToOriginalFont,
	fixStyleDataItem,
	getStyleCssVars,
	fontObjectToString,
	parseFontStr,
	parseFontWithCalc,
	getFontWithoutColor,
	addUrlProtocols,
	getFontFamilies,
	getSkinParams,
	getStyledTextUsedFonts,
	getFontFacesCss,
	determineFontFacesFontDisplay,
	getCSSObjectFromTransformationItem,
	getVariantsOrderScore,
	getMadeforFontFamillies,
	overrideFontSize,
	replaceSpxWithPx,
	extractFromQuotes,
	extractFontFamiliesFromCssProperties,
	getStylableCompCssWithOverrides,
	getHeightPixelValue,
	getRotationInDegrees,
	getWidthPixelValue,
	getBoxDimensionsBySkin,
	fixBorderHairline,
	getFontFamilyWithFallbacks,
	getDockedCssForCompLayouts,
	generateCss,
	getStylableCompCss,
	correctInlineColorStyle,
	correctInlineFontStyle,
	correctInlineFontStyleDesktop,
	mergeWithExternalSkinsInfo,
	isWeightBold,
} from './functionLibraryExtensions'
export {
	effectsFixer,
	stylesFixer,
	transformationFixer,
	convertTransitionDurations,
	buildInteractionsConfig,
	mergeReactionsByVariant,
	mergeBuilderComponentsInteractions,
	mergeInteractionConfig,
	deepCopyInteractionsConfig,
	getFillLayersColorsVars,
	makeSliderContainerConfig,
	buildConfigFromInteractionsRoot,
	getCompIdToInteractionsGraphRoot,
	getDataTypeToRefs
} from './functionLibraryExtensions'
export type {
	SkinDefaultsData,
	StylePropItem,
	HexColor,
	ColorFunction,
	RelativeColorFunction,
	LightDark,
	FontVariant,
	BackgroundLayer,
	ConicGradient,
	RadialGradient,
	LinearGradient,
	AxisRepeat,
	AxisPosition,
	BaselineAlignment,
	PositionalAlignSelf,
	StyleItemCustomEnum,
	PositionalJustifyContent,
	FilterFunction,
	FilterFunctions,
	BuilderFitContentFunction,
	BuilderAnchorSizeFunction
} from './functionLibraryExtensions'
export { getDockedStyles } from './dockedLayer'
export * from './apis/index'
export const stylable = _stylable
